import { render, staticRenderFns } from "./additional-buttons.vue?vue&type=template&id=59f6d585"
import script from "./additional-buttons.vue?vue&type=script&lang=js"
export * from "./additional-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports